import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionHelper } from 'app/shared/permissions/permissions';
import { Configuration, HttpClientCustom } from 'app/shared';
import { TranslateService } from '@ngx-translate/core';
import { ToasterComponent } from 'app/toasterComponent/toasterComponent';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from 'app/shared/sharedData';
import { AddOperationComponent } from './addOperation.component';

@Component({
    selector: 'manage-operation',
    templateUrl: 'manageOperation.component.html'
})

export class ManageOperationComponent {

    public _baseUrl: any;
    public pageSize: any = 10;
    public page = 0;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public trackHides: any;
    public operationList:any [];

    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate:TranslateService,
        public _toaster: ToasterComponent,
        vcr: ViewContainerRef,
        public modalService: NgbModal,
        public share: SharedData) {
            let self = this;
            self._baseUrl = _global.get('EPMS_BASE_URL');
            self._toaster.setViewRef(vcr);
        }

    public getAllOperations() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/operationDetails';
        self.http.get(url).subscribe((result) => {
            self.operationList = result;
            self.collectionSize = result.length;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, (error) => {
            console.log('Error:', error);
        })
    }

    public addOperation() {
        let self = this;
        self.share.saveData({operationDetailsData : {operation:"LEARNING_MANAGEMENT", "name":"", "externalURL": ""}});
        const modalRef = this.modalService.open(AddOperationComponent)
        .result.then((result) => {
            self.getAllOperations();
        }, (reason) => {});
    }

    public updateOperation(operationData) {
        let self = this;
        self.share.saveData({operationDetailsData : operationData});
        const modalRef = this.modalService.open(AddOperationComponent)
        .result.then((result) => {
            self.getAllOperations();
        }, (reason) => {});
    }

    
    // pagination functions
    public onPageChange(event: number): void {
        let self = this;
        if (event === 1) {
            self.startingPage = 1;
            self.endingPage = 10;
        } else {
            self.startingPage = 1 + self.pageSize;
            if (self.collectionSize > self.endingPage) {
                self.endingPage = event + self.endingPage;
            } else {
                self.endingPage = self.collectionSize;
            }
        }
        self.page = event - 1;
        self.getAllOperations();
    }
  
    public OnPageSizeChanged(val) {
        this.pageSize = val;
        this.getAllOperations();
    }
}



// WEBPACK FOOTER //
// ./src/app/tools/operations/manageOperation.component.ts